import React, {Component} from 'react';
import {connect} from 'react-redux';
import './styles.scss';
import {Loader} from '../../components';

class ScreenNotificationDefault extends Component {
  renderContentButton = () => {
    if (!this.props.contentButtons) {
      return (
        <div className="button-container-flex">
          <div className="button-container">
            <button className="button" onClick={this.props.actionButton}>
              {this.props.textButton}
            </button>
          </div>
        </div>
      );
    } else return this.props.contentButtons;
  };

  renderCustomContent = () => {
    if (this.props.contentCustom) return this.props.contentCustom;
    else
      return (
        <div className="info" style={this.props.styleInfo}>
          {this.props.content}
        </div>
      );
  };

  render() {
    return (
      <div className="div-screen-notification-default">
        <div className="header">{this.props.title}</div>
        <div className="content">{this.renderCustomContent()}</div>
        {this.renderContentButton()}
        <Loader />
      </div>
    );
  }
}

const mapStateToProps = ({loader}) => {
  return {loader};
};

export default connect(mapStateToProps, {})(ScreenNotificationDefault);
